import { buildFamsMenuMessages } from 'config/fams-menu';

export default {
  'menu.login': 'Login',
  'menu.account': 'Account',
  'menu.account.center': 'Profile',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.logout': 'Sign Out',
  ...buildFamsMenuMessages('en-US'),
};
